import React, { useState, useEffect } from 'react';
import styles from './SuccessState.module.css';

interface SuccessStateProps {
  onClose?: () => void;
}

export const SuccessState: React.FC<SuccessStateProps> = ({ onClose }) => {
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  // Generate confetti pieces with better falling behavior
  const confettiPieces = Array.from({ length: 100 }).map((_, i) => {
    const size = Math.random() * 12 + 6;
    const left = Math.random() * 100;
    const endX = (Math.random() - 0.5) * 100; // Horizontal movement range

    return {
      id: i,
      left: `${left}%`,
      animationDelay: `${Math.random() * 2}s`,
      color: `hsl(${Math.random() * 360}, 100%, 60%)`,
      size: `${size}px`,
      duration: `${2 + Math.random() * 3}s`, // 2-5 seconds
      endX: endX,
      borderRadius: Math.random() > 0.3 ? '50%' : '0'
    };
  });

  return (
    <div className={styles.successContainer}>
      {showConfetti && (
        <div className={styles.confetti}>
          {confettiPieces.map((piece) => (
            <div
              key={piece.id}
              className={styles.confettiPiece}
              style={{
                '--delay': piece.animationDelay,
                '--color': piece.color,
                '--size': piece.size,
                '--duration': piece.duration,
                '--end-x': piece.endX,
                '--border-radius': piece.borderRadius,
                'left': piece.left,
              } as React.CSSProperties}
            />
          ))}
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.header}>
          <h2>Application Submitted Successfully! 🎉</h2>
          <p>Thank you for your application! You will receive an email confirmation shortly with next steps.</p>
        </div>

        {onClose && (
          <button
            onClick={onClose}
            className={styles.closeButton}
            aria-label="Close success message and return to form"
            title="Close this success message"
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default SuccessState;
